import PointsBlock from './pointsBlock';
import GiftsBlock from './giftsBlock';
import {query} from 'api';
import PropTypes from 'prop-types';
import {Container, Title} from './styles';

const Gifts = ({data}) => {
  if (!data) return null;
  const {points: apiPoints, points_expiration} = data;
  const points = process.env.REACT_APP_DEV_POINTS
    ? Number(process.env.REACT_APP_DEV_POINTS)
    : apiPoints;
  return (
    <Container>
      <Title>Les cadeaux</Title>
      <PointsBlock points={points} points_expiration={points_expiration} />
      <GiftsBlock userPoints={points} />
    </Container>
  );
};

Gifts.propTypes = {
  data: PropTypes.object,
};

export default Gifts |> query('getProfile', {loadingFullWidth: true});
